export const THIRTY_SECONDS = 30 * 1000
export const MILLISECONDS_TO_SECONDS_DIVISER = 1000